import React, {ChangeEvent, useEffect, useRef, useState} from 'react';
import {agregarEditarPlantilla, mostrarPlantillaById} from '../../redux/reducers/plantillasReducers';
import LoadingProgress from "../../components/LoadingProgress";
import {geoString, getLSLang} from "../../helpers";
import Strings from "../../assets/strings";
import {
    Alert,
    alpha,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    Grid,
    Switch,
    TextField,
    Theme,
    Typography
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Button from "@mui/material/Button";
import {useNavigate, useParams} from "react-router-dom";
import {AppBar, MostrarError} from "../../components";
import {IPlantilla} from "../../redux/types/IPlantilla";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import Box from "@mui/material/Box";
import {Close, Save} from "@mui/icons-material";
import {MenuItemData, NestedDropdown} from 'mui-nested-menu';
import {Editor} from "@tinymce/tinymce-react";
import {Editor as TinyMCEEditor} from 'tinymce';
import {useCustomFormInput} from "../../hooks/useCustomFormInput";
import {ConfCamposType} from "../../redux/types/ICompania";
import {htmlToPDF} from "../../makePDF/htmlToPDF";
import {getTokenInfo} from "../../services/auth";
import openAdjunto from "../../helpers/openAdjunto";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
        padding: 20,
        "& .tox-tinymce":{
            border: "1px solid "+theme.palette.grey[200],
            borderRadius: 0
        }
    },
    shortCont:{
        border: "1px solid "+theme.palette.grey[200],
        boxSizing: "border-box",
        width: "100%",
        resize: "none",
        outline: "none",
        padding: "10px",
        fontSize: "15px"
    },
    topMenu:{
        display:"flex",
        marginTop:5,
        background:theme.palette.grey[200],
        "&>div>button":{
            textTransform: "capitalize",
        },
        "&>button":{
            marginLeft: "auto"
        }
    },
    checkBox:{
        marginLeft: 0,
        size: 10,
        color: theme.palette.primary.main
    },
    checkBoxCont:{
        padding: "0 8px",
        borderLeft: "1px solid #e0e0e0",
        "&:hover":{
            background: alpha(theme.palette.primary.light, 0.1)
        }
    }
}));
let initialState:IPlantilla = {
    id: undefined,
    nombre: "",
    descripcion: "",
    contenido: "",
    porDefecto: false,
    mostrarEncabezado: true,
    tamanoPagina: "LETTER",
}
const language = getLSLang("l")

export default function CrearPlantilla(){
    const classes = useStyles();
    const navigate = useNavigate();

    const customFormInputCli = useCustomFormInput()  as ConfCamposType;;
    const customFormInputPre = useCustomFormInput("pre")  as ConfCamposType;
    let { plaId:urlPlaId} = useParams()
    const Dispatch = useAppDispatch();
    const {byId:platilla,status,error} = useAppSelector(state => state.plantillas)
    const [state, setState] = useState(initialState);
    const shortCont = useRef<any>(null);

    useEffect(()=>{
        if(urlPlaId) Dispatch(mostrarPlantillaById(parseInt(urlPlaId)));
    },[urlPlaId,Dispatch])
    useEffect(()=>{
        if(urlPlaId && platilla?.id === parseInt(urlPlaId)) {
            setState({...initialState, ...platilla});
        }else{
            setState(initialState)
        }
    },[urlPlaId,platilla])

    const handleChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
        const {name,value, type, checked} = e.target
        setState({...state,[name]: type === "checkbox" ?checked:value});
    }
    const submit = (e:React.FormEvent<HTMLFormElement>) =>{
        e.preventDefault();
        let obj = {...state}

        Dispatch(agregarEditarPlantilla(obj)).then(res=>{
            if(res.payload){
                setState((res.payload as any).data)
            }
        });
    }

    const duplicar = () =>{
        let copyState = {...state,nombre: state.nombre + " - "+Strings.copia, registroDelSistema: false, id:undefined }
        return setState(copyState);
    }

    const insertarParam = (params:string) =>{
        let textarea = shortCont.current;
        if(textarea){
            let start_position = textarea.selectionStart;
            let end_position = textarea.selectionEnd;

            let descripcion  = `${textarea.value.substring(0,
                start_position
            )} ${params} ${textarea.value.substring(
                end_position,
                textarea.value.length
            )}`;

            setState(prevState => ({...prevState, descripcion}))

            textarea.setSelectionRange(end_position, end_position);
            textarea.focus();

        }
    }

    const menuItemsData = (onInsert:(params:string)=>void): MenuItemData => {
        return {
            label: 'Parametros',
            items: [
                {
                    label: Strings.empresa,
                    items: [
                        {
                            label: Strings.prestador+" "+Strings.nombreCompleto,
                            callback: () => onInsert('$PrestadorNombre')
                        }, {
                            label: Strings.prestador+" "+Strings.direccion,
                            callback: () => onInsert('$PrestadorDireccion')
                        }, {
                            label: Strings.empresa,
                            callback: () => onInsert('$EmpresaNombre')
                        },{
                            label: Strings.direccion,
                            callback: () => onInsert('$EmpresaDireccion')
                        },{
                            label: Strings.telefono,
                            callback: () => onInsert('$EmpresaTelefono')
                        },{
                            label: Strings.celular,
                            callback: () => onInsert('$EmpresaCelular')
                        },{
                            label: Strings.email,
                            callback: () => onInsert('$EmpresaEmail')
                        }, {
                            label: Strings.interes,
                            callback: () => onInsert('$MoraInteres')
                        }, {
                            label: geoString("rnc",true),
                            callback: () => onInsert('$EmpresaRnc')
                        }, {
                            label: Strings.mora,
                            items: [
                                {
                                    label: Strings.diasDeGracia,
                                    callback: () => onInsert(' $MoraDiasGracia ')
                                }, {
                                    label: Strings.interes,
                                    callback: () => onInsert(' $PorcientoMora ')
                                }, {
                                    label: Strings.interes+" ("+Strings.letra+")",
                                    callback: () => onInsert(' $LPorcientoMora ')
                                }
                            ]
                        }

                    ]
                },
                {

                    label: Strings.prestatario,
                    items: [...[
                        {

                            label: Strings.infoCompleta,
                            callback: ()=> {
                                onInsert('$ClienteInfo');
                            }
                        }, {

                            label: Strings.nombreCompleto,
                            callback: ()=> {
                                onInsert('$ClienteNombre');
                            }
                        }, {

                            label: Strings.apellidos,
                            callback: ()=> {
                                onInsert('$ClienteApellido');
                            }
                        }, {

                            label: Strings.cedula,
                            callback: ()=> {
                                onInsert('$ClienteCedula');
                            }
                        }, {

                            label: Strings.direccion,
                            callback: ()=> {
                                onInsert('$ClienteDireccion');
                            }
                        }, {

                            label: Strings.telefono,
                            callback: ()=> {
                                onInsert('$ClienteTelefono');
                            }
                        }, {

                            label: Strings.nacionalidad,
                            callback: ()=> {
                                onInsert('$ClienteNacionalidad');
                            }
                        }, {

                            label: Strings.condicionesLaboral,
                            callback: ()=> {
                                onInsert('$ClienteCondicionesLaboral ');
                            }
                        }, {

                            label: Strings.posicion,
                            callback: ()=> {
                                onInsert('$ClienteTrabajoOcupacion ');
                            }
                        }
                    ],
                        ...(Object.keys(customFormInputCli || {}).map(e=>({
                            label: customFormInputCli[e]?.name,
                            callback: ()=> {
                                onInsert('$'+e.charAt(0).toUpperCase() + e.slice(1));
                            }
                        })))
                    ]
                },
                {

                    label: Strings.codeudor,
                    items: [
                        {

                            label: Strings.nombreCompleto,
                            callback: ()=> {
                                onInsert('$CodeudorNombre');
                            }
                        }, {

                            label: Strings.cedula,
                            callback: ()=> {
                                onInsert('$CodeudorCedula');
                            }
                        }, {

                            label: Strings.direccion,
                            callback: ()=> {
                                onInsert('$CodeudorDireccion');
                            }
                        }, {
                            label: Strings.telefono,
                            callback: ()=> {
                                onInsert('$CodeudorTelefono');
                            }
                        }
                    ]
                },
                {

                    label: Strings.prestamo,
                    items: [...[
                        {

                            label: Strings.fecha,
                            items: [
                                {

                                    label: Strings.fechaApertura,
                                    callback: ()=> {
                                        onInsert('$PrestamoFechaDesembolso ');
                                    }
                                },
                                {

                                    label: Strings.fechaApertura+" ("+Strings.letra+")",
                                    callback: ()=> {
                                        onInsert('$LPrestamoFechaDesembolso ');
                                    }
                                },
                                {

                                    label: Strings.fechaTermino,
                                    callback: ()=> {
                                        onInsert('$PrestamoFechaTermino ');
                                    }
                                },
                                {

                                    label: Strings.fechaTermino+" ("+Strings.letra+")",
                                    callback: ()=> {
                                        onInsert('$LPrestamoFechaTermino ');
                                    }
                                },
                                {

                                    label: Strings.fecha+" "+Strings.primerPago,
                                    callback: ()=> {
                                        onInsert('$PrestamoFechaPrimerPago ');
                                    }
                                },
                                {

                                    label: Strings.anio,
                                    callback: ()=> {
                                        onInsert('$PrestamoAno ');
                                    }
                                },
                                {

                                    label: Strings.anio+" ("+Strings.letra+")",
                                    callback: ()=> {
                                        onInsert('$LPrestamoAno ');
                                    }
                                },
                                {

                                    label: Strings.mes,
                                    callback: ()=> {
                                        onInsert('$PrestamoMes ');
                                    }
                                },
                                {

                                    label: Strings.mes+" ("+Strings.letra+")",
                                    callback: ()=> {
                                        onInsert('$LPrestamoMes ');
                                    }
                                },
                                {

                                    label: Strings.dia,
                                    callback: ()=> {
                                        onInsert('$PrestamoDia ');
                                    }
                                },
                                {

                                    label: Strings.dia+" ("+Strings.letra+")",
                                    callback: ()=> {
                                        onInsert('$LPrestamoDia ');
                                    }
                                }
                            ]
                        }, {

                            label: Strings.codigoRef,
                            callback: ()=> {
                                onInsert('$PrestamoRef');
                            }
                        }, {

                            label: Strings.capitalActual,
                            callback: ()=> {
                                onInsert('$PrestamoCapitalActual');
                            }
                        },{

                            label: Strings.amortizacion,
                            callback: ()=> {
                                onInsert('$PrestamoTipoAmortizacion');
                            }
                        },
                        {

                            label: Strings.interes,
                            callback: ()=> {
                                onInsert('$PrestamoInteres');
                            }
                        },{

                            label: Strings.letra+" "+Strings.interes,
                            callback: ()=> {
                                onInsert('$LPrestamoInteres');
                            }
                        }, {

                            label: Strings.plazo,
                            callback: ()=> {
                                onInsert('$PrestamoPlazo');
                            }
                        }, {
                            label: `${Strings.capital} ${Strings.inicial}`,
                            callback: ()=> {
                                onInsert('$PrestamoCapitalInicial');
                            }
                        }, {
                            label: `${Strings.capital} ${Strings.inicial} (${Strings.letra})`,
                            callback: ()=> {
                                onInsert('$LPrestamoCapitalInicial');
                            }
                        }, {

                            label: Strings.monto+" "+Strings.cuota,
                            callback: ()=> {
                                onInsert('$PrestamoMontoCuota');
                            }
                        }, {

                            label: Strings.monto+" "+Strings.cuotas+" ("+Strings.letra+")",
                            callback: ()=> {
                                onInsert('$LPrestamoMontoCuota ');
                            }
                        }, {

                            label: Strings.totalApagar,
                            callback: ()=> {
                                onInsert('$PrestamoTotalPagos');
                            }
                        },{

                            label: Strings.totalPagado+" ("+Strings.letra+")",
                            callback: ()=> {
                                onInsert('$LPrestamoTotalPagos');
                            }
                        },
                        {

                            label: Strings.total+" "+Strings.interes,
                            callback: ()=> {
                                onInsert('$PrestamoTotalInteres');
                            }
                        },
                        {

                            label: Strings.total+" "+Strings.interes+" ("+Strings.letra+")",
                            callback: ()=> {
                                onInsert('$LPrestamoTotalInteres');
                            }
                        },
                        {

                            label: Strings.balance,
                            callback: ()=> {
                                onInsert('$PrestamoBalance');
                            }
                        },
                        {

                            label: Strings.balance+" ("+Strings.letra+")",
                            callback: ()=> {
                                onInsert('$LPrestamoBalance');
                            }
                        }

                    ],
                        ...(Object.keys(customFormInputPre??{}).map(e=>({
                            label: (customFormInputPre[e])?.name,
                            callback: ()=> {
                                onInsert('$'+e.charAt(0).toUpperCase() + e.slice(1));
                            }
                        })))
                    ]
                },
                {
                    label: Strings.fecha,
                    callback:  () => {
                        onInsert('$FechaActual');
                    }

                },
                {
                    label: Strings.letra+" "+Strings.fecha,
                    callback:  () => {
                        onInsert('$LFechaActual');
                    }

                }

            ]
        }
    }

    const editorRef = useRef<TinyMCEEditor | null>(null);
    const optInsertar:MenuItemData = {
        label: 'Insertar',
        items: [
            {
                label: "Una columna",
                callback: ()=> editorRef.current!.insertContent('<table style="width: 100%; text-align: center;"> <tbody> <tr> <td> <p>$ClienteNombre $ClienteApellido <br>____________________________<br>Firma</p> </td> </tr> </tbody> </table>')
            },
            {
                label: "Dos columnas",
                callback: ()=> editorRef.current!.insertContent('<table style="width: 100%; text-align: center;"> <tbody> <tr> <td> <p>$ClienteNombre $ClienteApellido <br>____________________________<br>Deudor</p> </td> <td> <p>$PrestadorNombre<br>____________________________<br>Acreedor</p> </td> </tr> </tbody> </table>')
            }
        ]
    }
    const optPageSize:MenuItemData = {
        label: !!state.tamanoPagina ? state.tamanoPagina : 'Tamaño',
        items: [
            {
                label: "Letter",
                callback: ()=> setState(prev=>({...prev, tamanoPagina:"LETTER"}))
            },
            {
                label: "Legal",
                callback: ()=> setState(prev=>({...prev, tamanoPagina:"LEGAL"}))
            },
            {
                label: "58mm",
                callback: ()=> setState(prev=>({...prev, tamanoPagina:"58mm"}))
            },
            {
                label: "80mm",
                callback: ()=> setState(prev=>({...prev, tamanoPagina:"80mm"}))
            }
        ]
    }


    const setting = {
        language,
        paste_as_text:true,
        menubar: false,
        height: 500,
        branding: false,
        inline_boundaries: false,
        inline_boundaries_selector: 'em',
        // statusbar: false,
        //
    //    plugins: 'code table',
        //plugins: 'code  template table searchreplace directionality insertdatetime', //insert
       // toolbar: 'undo redo | template | contrato | parametros | table | formatselect  | bold italic underline strikethrough  | alignleft aligncenter alignright alignjustify  | code |  searchreplace removeformat',
  //      toolbar: 'undo redo | table | formatselect  | bold italic underline strikethrough | formatselect | alignleft aligncenter alignright alignjustify  | removeformat | code ',
        image_advtab: true,

        plugins: [
            'code', 'lists', 'fullscreen'
        ],
        toolbar: 'undo redo  | fontsizeinput |' +
            'bold italic underline strikethrough | forecolor | alignleft aligncenter ' +
            'alignright alignjustify | lineheight | bullist numlist | removeformat | fullscreen | code ',
        table_toolbar: '',
        table_advtab: false,
        table_row_advtab: false,
        table_cell_advtab: false,
        table_appearance_options: false,
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        // templates: [
        //     { title: Strings.contrato, description:"", url: "/contratoTemplate/"+language+"/contrato.html" },
        //     { title: Strings.pagareNotarial, description:"", url: "/contratoTemplate/"+language+"/pagare.html" }
        // ],
        mobile: {
            theme: 'silver',
        },
    }



    return(
        <>
            <AppBar title={(state.id ? Strings.editar:Strings.crear )+" "+Strings.plantilla }/>

            <section className={"contentInner "+classes.root} >
                <MostrarError errors={error}/>
                {(status === "loading") && <LoadingProgress vh/>}
                {state.registroDelSistema &&
                    <>
                        <Alert icon={false} color={"warning"}
                            action={
                                <Button color="inherit" size="small" onClick={duplicar}>
                                    {Strings.duplicar}
                                </Button>
                            }
                        >
                            {Strings.registroDelSistemaMsj}
                        </Alert>
                        <br/>
                    </>
                }





                <form id="form1" onSubmit={submit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={4}>
                            <TextField
                                name={"nombre"}
                                label={Strings.nombre}
                                value={state.nombre}
                                onChange={handleChange}
                                inputProps={{maxLength: 50}}
                                required
                                disabled={state.registroDelSistema}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel className="d-print-none" sx={{margin: 0}}
                                              control={
                                                  <Switch
                                                      size={"small"}
                                                      name={"porDefecto"}
                                                      checked={state.porDefecto}
                                                      onChange={handleChange}
                                                      // value="checkedB"
                                                  />
                                              }
                                              label={"Usar esta plantilla por defecto."}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography>{Strings.descripcion} *</Typography>
                            <div className={classes.topMenu}>
                                <NestedDropdown
                                    menuItemsData={menuItemsData(insertarParam)}
                                    // MenuProps={{elevation: 3}}
                                    ButtonProps={{disabled:state.registroDelSistema}}
                                />

                            </div>
                            <textarea
                                ref={shortCont}
                                name={"descripcion"}
                                rows={4}
                                // label={"Contenido corto"}
                                value={state.descripcion}
                                onChange={({target})=>setState(prev=>({...prev, descripcion: target.value}))}
                                required
                                disabled={state.registroDelSistema}
                                className={classes.shortCont}
                            />
                        </Grid>
                        <Grid item xs={12}>

                            <Typography>Contenido</Typography>


                            <div className={classes.topMenu} style={{
                                overflow:"auto"
                            }}>
                                    <NestedDropdown
                                        menuItemsData={menuItemsData((v)=>editorRef.current!.insertContent(v))}
                                        // MenuProps={{elevation: 3}}
                                        ButtonProps={{ disabled:state.registroDelSistema}}
                                    />
                                <NestedDropdown
                                    menuItemsData={optInsertar}
                                    // MenuProps={{elevation: 3}}
                                    ButtonProps={{ disabled:state.registroDelSistema}}
                                />
                                {!["654", "375"].includes((getTokenInfo() as any)?.CompanyId) && <>

                                    <NestedDropdown
                                        menuItemsData={optPageSize}
                                        // MenuProps={{elevation: 3}}
                                        ButtonProps={{ disabled:state.registroDelSistema}}
                                    />
                                    <Box className={classes.checkBoxCont}>
                                        <FormControlLabel
                                            disabled={!!state.registroDelSistema}
                                            control={<Checkbox size={"small"} checked={!!state.mostrarEncabezado} onChange={({target})=>setState({...state, mostrarEncabezado:target.checked})}/>}
                                            label="Encabezado"
                                            className={classes.checkBox}
                                            labelPlacement="start"
                                        />
                                    </Box>
                                </>}


                            </div>
                            <Editor disabled={!!state.registroDelSistema}
                                    value={state?.contenido??""}
                                    init={setting}
                                    onInit={(_evt, editor) => {
                                        return  editorRef.current = editor
                                    }}
                                    apiKey='wz24bwywc9e9y0hrtovishcbc4en66fzp25qnun8qjlxzkcj'
                                    {...(handleChange && {
                                        onEditorChange : (content)=> handleChange({target:{name:"contenido", value: content}} as ChangeEvent<HTMLInputElement>)
                                    })}
                            />


                            {/*<ContratoEditor*/}
                            {/*    disabled={!!state.registroDelSistema}*/}
                            {/*    name={"contenido"}*/}
                            {/*    value={state.contenido??""}*/}
                            {/*    onChange={handleChange}/>*/}

                        </Grid>

                    </Grid>
                </form>



                <Box className={"formControl"}>

                    {!["654", "375"].includes((getTokenInfo() as any)?.CompanyId) &&
                        <Button
                            disabled={!state?.contenido}
                            size={"small"}
                            sx={{mr:"auto"}}
                            onClick={()=>{
                                htmlToPDF(state?.contenido??"", state.tamanoPagina, state.mostrarEncabezado).then(pdfDocGenerator=>{
                                    pdfDocGenerator.getBase64((base64)=>{
                                        openAdjunto("data:application/pdf;base64,"+base64)
                                    })
                                })
                            }}
                        >
                            Ver PDF
                        </Button>
                    }
                    <Button sx={{mr:0.5}} color={"error"} onClick={()=>navigate(-1)} variant={"outlined"} disabled={status==="loading"} startIcon={<Close/>} size={"small"}>{Strings.cancelar}</Button>
                    {!state.registroDelSistema &&
                        <Button type={"submit"}  form={"form1"} variant={"outlined"} disabled={status==="loading"}  startIcon={<Save/>} size={"small"}>
                            {status === "loading"? (
                                <span><CircularProgress size={14} color="inherit" /> &nbsp; {Strings.cargando}</span>
                            ):(
                                <span>{Strings.guardar}</span>
                            )}
                        </Button>
                    }
                </Box>
            </section>
        </>
    )
}

